import dashboard from '../../assets/images/svg/dashboard.svg'
import dashboardActive from '../../assets/images/svg/dashboard-active.svg'
export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: dashboard,
    iconActive: dashboardActive,
  },
  // {
  //   title: 'Dashboards',
  //   icon: 'HomeIcon',
  //   tag: '2',
  //   tagVariant: 'light-warning',
  //   children: [
  //     {
  //       title: 'eCommerce',
  //       route: 'dashboard-ecommerce',
  //     },
  //     {
  //       title: 'Analytics',
  //       route: 'dashboard-analytics',
  //     },
  //   ],
  // },
]
